import { config } from '../config';

const API_URL = config.API_URI;

/**
 * Fetch the purchasable lifetime (LTD) tier catalog and the active payment
 * provider. Public endpoint — cached by the backend.
 * @returns {Promise<{ tiers: Array, provider: 'stripe'|'paddle' }>}
 */
export const fetchLifetimeTiers = async () => {
  try {
    const response = await fetch(`${API_URL}/v1/lifetime/tiers`, {
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error('Failed to fetch lifetime tiers');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching lifetime tiers:', error);
    throw error;
  }
};

/**
 * Create a lifetime checkout for a tier on the active provider. Workspace-scoped
 * (the lifetime applies to a workspace), so `workspaceId` is the workspace
 * shortId — the backend resolves it via shortId, matching DealMirror.
 *
 * @param {Object} params
 * @param {'tier1'|'tier2'|'tier3'} params.tier
 * @param {string} params.workspaceId  workspace shortId
 * @returns {Promise<Object>} Stripe { provider:'stripe', clientSecret, paymentIntentId, ... }
 *   or Paddle { provider:'paddle', transactionId, ... }
 */
export const createLifetimeCheckout = async ({ tier, workspaceId }) => {
  const response = await fetch(`${API_URL}/v1/lifetime/checkout`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ tier, workspaceId }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || data.message || 'Failed to create lifetime checkout');
  }
  return data;
};
